package com.devi3east.bashbuddy.auth.navigation

import androidx.navigation.NavBackStackEntry
import androidx.navigation.NavGraphBuilder
import androidx.navigation.compose.composable
import androidx.navigation.navDeepLink
import com.devi3east.bashbuddy.auth.ui.ResetPasswordScreenRoute
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen
import com.devi3east.bashbuddy.features.common.data.api.BASE_URL

fun NavGraphBuilder.resetPasswordNavGraph(
    appState: AppState
) {
    composable(
        route = Screen.ResetPasswordScreen.route,
        deepLinks = listOf(
            navDeepLink {
                this.uriPattern = "bashbuddyapp://reset"
            },
            navDeepLink {
                this.uriPattern = "{$BASE_URL}/reset"
            }
        )
    ) { backStackEntry: NavBackStackEntry ->
        val destRoute = backStackEntry.destination.route ?: ""

        ResetPasswordScreenRoute(
            appState = appState,
            deepLinkRoute = destRoute
        )
    }
}